export enum Action {
  C = 'create',
  R = 'read',
  U = 'update',
  D = 'delete',
  S = 'search'
}
